import { useState, useEffect } from "react";

import accountSettings from "../data/account-settings";

const useAccountSettings = ({ accountId: initAccountId }) => {
  const [settings, setSettings] = useState({});
  const [accountId, setAccountId] = useState(initAccountId);

  useEffect(() => {
    if (!accountId) {
      return;
    }
    accountSettings({ accountId })
      .then(settings => setSettings(settings))
      .catch(err => {
        setSettings(err);
      });
  }, [accountId]);

  return [settings, setAccountId];
};

export default useAccountSettings;
